<template>
  <v-dialog v-model="active" class="the-message-alert" max-width="450" persistent>
    <v-card dark color="white">
      <v-card-title :class="config[type].color">
        {{ title || config[type].title }}
      </v-card-title>
      <v-card-text class="d-flex flex-column pa-6 py-4">
        <v-icon size="128" :color="config[type].color">{{ config[type].icon }}</v-icon>
        <v-sheet class="pa-4 mt-2 rounded-lg" color="blue-grey">
          {{ message }}
        </v-sheet>
      </v-card-text>
      <v-divider light></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close()" width="100px">確定</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TheMessageAlert",
  props: {
    active: {
      type: Boolean,
      required: true
    },
    title: {
      type: String
    },
    message: {
      type: String
    },
    type: {
      type: String,
      default: "info",
      validator(value) {
        return ["info", "error", "warning"].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      config: {
        info: {
          title: "Info",
          icon: "mdi-alert-circle",
          color: "primary"
        },
        error: {
          title: "Error",
          icon: "mdi-close-circle",
          color: "error"
        },
        warning: {
          title: "Warning",
          icon: "mdi-alert",
          color: "warning"
        }
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.v-icon::after {
  width: 0 !important;
}
</style>
